/*
 * @Author: Chao Yang
 * @Date: 2020-08-05 02:00:48
 * @LastEditor: Chao Yang
 * @LastEditTime: 2020-08-13 01:42:13
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { YearPickerComponent } from './year-picker/year-picker.component';
import { MonthPickerComponent } from './month-picker/month-picker.component';

@NgModule({
  declarations: [MonthPickerComponent, YearPickerComponent],
  exports: [MonthPickerComponent, YearPickerComponent],
  imports: [CommonModule],
  //entryComponents: [MonthPickerComponent, YearPickerComponent],
})
export class AdCommonModule {}
export { MonthPickerComponent, YearPickerComponent };
